import React, { Fragment, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
    useParams
} from "react-router-dom";

import { searchDataForFiltersAction } from '../../redux/actions/productAction'
import PagenationForProduct from './pagenationForProduct';
import Navbar from '../HomeScreen/Navbar'
import Footer from '../HomeScreen/bottomsection/Footer'
import SearchItems from './SearchItems'

import NotFoundImage from '../../images/not-found.png'
import Loader from '../../layout/loader';
import MetaTag from '../../layout/MetaTag';

import './search.css'

const safeRouteText = (value) => {
    if (typeof value !== 'string') return '';
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
}

function SearchDataAndFilters() {

    let { SearchData } = useParams();
    const decodedSearchData = safeRouteText(SearchData || '');

    const dispatch = useDispatch();

    const { product, loading } = useSelector(state => state.searchData)
    const searchedProducts = Array.isArray(product) ? product : [];



    const itemsPerPage = 20;

    useEffect(() => {
        dispatch(searchDataForFiltersAction(decodedSearchData))
    }, [decodedSearchData, dispatch])


    return (
        <Fragment>
            <MetaTag
                title={`${decodedSearchData} Shoes | Search Results | IM Online Shop`}
                description={`Shop ${decodedSearchData} shoes, sneakers, and footwear at IM Online Shop.`}
                keywords={`${decodedSearchData} shoes, ${decodedSearchData} sneakers, buy shoes online, IM Online Shop`}
            />

            <Navbar />
            {loading ? <Loader /> : (<Fragment>

                {searchedProducts.length === 0 ? (<Fragment>
                    <main className="product-not-found-container">
                        <div className="image-div-of-not-found">
                            <img src={NotFoundImage} alt="No matching products found" />
                        </div>
                        <span>No matches found</span>
                        <h1>We could not find “{decodedSearchData}”</h1>
                        <p>Try another brand, category, or shorter keyword.</p>
                        <div className="not-found-search-panel">
                            <SearchItems initialValue={decodedSearchData} />
                        </div>
                    </main>
                </Fragment>) : (
                    <Fragment>

                        <main className="search-results-page">
                            <section className="search-results-header">
                                <div>
                                    <span>Search Results</span>
                                    <h1>{decodedSearchData}</h1>
                                    <p>{searchedProducts.length} products found. Compare styles, ratings, and prices before choosing your pair.</p>
                                </div>
                                <SearchItems initialValue={decodedSearchData} />
                            </section>

                            <PagenationForProduct product={searchedProducts} itemsPerPage={itemsPerPage} loading={loading} />
                        </main>
                    </Fragment>

                )}

            </Fragment>)}
            <Footer />
        </Fragment>
    )
}

export default SearchDataAndFilters
